/** @jsx jsx */
import { graphql, useStaticQuery } from "gatsby";
import { jsx, Box, Heading, Paragraph } from "theme-ui";
import Action from "./Action";
import { GatsbyImage } from 'gatsby-plugin-image';

const SidebarCTABanner = ({ ctaBanner }) => {
  const { contentfulCallToActionBanner } = useStaticQuery(graphql`
      query {
          contentfulCallToActionBanner(
              bannerTitle: { eq: "Blog Signup Banner" }
          ) {
              bannerHeading  
              bannerText
              bannerAction {
                  ...ActionFragment
              }
              backgroundImage {
                  gatsbyImageData
              }
          }
      }
  `);

  const bannerData = ctaBanner || contentfulCallToActionBanner;

  const { bannerHeading, bannerText, bannerAction, backgroundImage } = bannerData;

  return (
    <Box  sx={{
      marginTop:'20px',
      border: '5px solid rgb(39, 39, 99)',
      justifyContent:'center',
      maxWidth: '278px',
      textAlign: 'center'
    }}>
      <Heading as="h6"
        sx={{
          fontSize: "20px",
          fontWeight: 'bold',
          my: 0,
          px: '10px',
          py: '10px' }}
      >
        {bannerHeading}
      </Heading>
      <Paragraph
        sx={{ fontSize: ['14px', '18px'], my: 0, px: '10px', mb: '0.5em', lineHeight: '0.5em' }}
      >
        {bannerText}
      </Paragraph>
      <Action
        label={bannerAction.label}
        actionEvent={bannerAction.actionEvent}
        form={bannerAction.form}
        hubspotForm={bannerAction.hubspotForm}
        icon={bannerAction.icon}
        iconSize={bannerAction.iconSize}
        style={bannerAction.style}
        url={bannerAction.url}
        fontsize="16px"
        sx={{
          textDecoration: 'none', mt: 2, margin: 'auto'
        }}
      />
      {backgroundImage &&
        <Box sx={{marginTop:'0'}}>
          <GatsbyImage
            image={backgroundImage?.gatsbyImageData}
            alt="Banner Image"
            sx={{
              maxWidth: "100%",
              width: "100%",
            }}
          />
        </Box>
      }
    </Box>
  );
};

export default SidebarCTABanner;
